import {
  EDealType,
  EEntityType,
} from '../../../repositories/favorites/entities/delete_user_favorites/DeleteOfferFromFavoritesRequest';
import {
  fetchDeleteOfferFromFavorites,
  TDeleteOfferFromFavoritesResponse,
} from '../../../repositories/favorites/v1/delete-offer-from-favorites';
import { ResponseError } from '../../../utils/errors';
import { IThunkContext } from 'shared/types/redux';

export type TDeleteFromFavoriteParameters = {
  offerId: number;
  dealType: EDealType;
  entityType: EEntityType;
};

export async function deleteFromFavoriteRequest(
  context: IThunkContext,
  parameters: TDeleteFromFavoriteParameters,
): Promise<void> {
  const { logger, httpApi } = context;
  const { offerId, dealType, entityType } = parameters;

  try {
    const response: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({
      httpApi,
      parameters: {
        entityId: offerId,
        dealType,
        entityType,
      },
    });

    if (response.statusCode !== 200) {
      /* istanbul ignore next */
      throw new ResponseError({
        domain: 'deleteFromFavorite',
        message: response.response.message || 'Код ответа не 200',
        details: { errors: JSON.stringify(response.response.errors) },
      });
    }
  } catch (error) {
    logger.error(error, {
      offerId,
      domain: 'deleteFromFavorite',
    });

    throw error;
  }
}
